export const ProfessionalActionTypes = {
    PROFESSIONAL_LIST_GET: 'PROFESSIONAL_LIST_GET',
    PROFESSIONAL_LIST_GET_SUCCESSFUL: 'PROFESSIONAL_LIST_GET_SUCCESSFUL',
    PROFESSIONAL_LIST_GET_ERROR: 'PROFESSIONAL_LIST_GET_ERROR',

    // Query management actions
    SET_PROFESSIONAL_QUERY: 'SET_PROFESSIONAL_QUERY',
    RESET_PROFESSIONAL_QUERY: 'RESET_PROFESSIONAL_QUERY',

    PROFESSIONAL_SHOW_REMOVE_MODAL: 'PROFESSIONAL_SHOW_REMOVE_MODAL',
    PROFESSIONAL_SHOW_REMOVE_MODAL_SUCCESS: 'PROFESSIONAL_SHOW_REMOVE_MODAL_SUCCESS',

    PROFESSIONAL_REMOVE: "PROFESSIONAL_REMOVE",
    PROFESSIONAL_REMOVE_SUCCESS: 'PROFESSIONAL_REMOVE_SUCCESS',
    PROFESSIONAL_REMOVE_ERROR: 'PROFESSIONAL_REMOVE_ERROR',

    PROFESSIONAL_APPROVE: 'PROFESSIONAL_APPROVE',
    PROFESSIONAL_EDIT: 'PROFESSIONAL_EDIT',
    PROFESSIONAL_EDIT_SUCCESS: 'PROFESSIONAL_EDIT_SUCCESS',
    PROFESSIONAL_EDIT_ERROR: 'PROFESSIONAL_EDIT_ERROR',

    PROFESSIONAL_TRANSLATION_EDIT: 'PROFESSIONAL_TRANSLATION_EDIT',
    PROFESSIONAL_TRANSLATION_EDIT_SUCCESS: 'PROFESSIONAL_TRANSLATION_EDIT_SUCCESS',
    PROFESSIONAL_TRANSLATION_EDIT_ERROR: 'PROFESSIONAL_TRANSLATION_EDIT_ERROR',

    DISABLE: 'DISABLE',
    REMOVE: 'REMOVE'
}
